<template>
  <posts-show />
</template>

<script>
import PostsShow from '../../components/posts/Show'

export default {
  name: 'PostsPageShow',
  components: { PostsShow }
}
</script>

<style scoped>
  /* Always export scoped styles to not break the app */
</style>
